import { render, staticRenderFns } from "./ArrivalOrders.vue?vue&type=template&id=ff289eac&scoped=true"
import script from "./ArrivalOrders.vue?vue&type=script&lang=js"
export * from "./ArrivalOrders.vue?vue&type=script&lang=js"
import style0 from "./ArrivalOrders.vue?vue&type=style&index=0&id=ff289eac&prod&lang=less&scoped=true"
import style1 from "./ArrivalOrders.vue?vue&type=style&index=1&id=ff289eac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff289eac",
  null
  
)

export default component.exports